<template>
    <hc-dialog
        :close-on-click-modal="false"
        title="导入/更新"
        width="720px"
        :visible.sync="visible"
        class="import-dialog"
    >
        <hc-form ref="form" label-position="left" label-width="155px" :model="form" :rules="rules">
            <hc-form-item label="导入环境" prop="importBusinessEnvId">
                <tree-select
                    v-model="form.importBusinessEnvId"
                    :options="treeConfig.evnTypeTree"
                    :props="treeConfig.propsConfig"
                    select-class-name="envType"
                    @input="()=>{validateEnvTypeField('targetBusinessEnvId')}"
                />
            </hc-form-item>
            <hc-form-item label="目标环境" prop="targetBusinessEnvId">
                <tree-select
                    v-model="form.targetBusinessEnvId"
                    :options="treeConfig.evnTypeTree"
                    :props="treeConfig.propsConfig"
                    select-class-name="envType"
                    @input="()=>{validateEnvTypeField('importBusinessEnvId')}"
                />
            </hc-form-item>
            <hc-form-item label="导入/更新策略" prop="strategy" class="strategy">
                <hc-select v-model="form.strategy" placeholder="请选择策略" size="small">
                    <hc-option v-for="item in types" :key="item.value" :label="item.label" :value="item.value" />
                </hc-select>
            </hc-form-item>
        </hc-form>
        <div slot="footer">
            <hc-button type="plain" @click="visible = false">
                取消
            </hc-button>
            <hc-button type="primary" :loading="loading.save" @click="onSave">
                保存
            </hc-button>
        </div>
    </hc-dialog>
</template>

<script>
import TreeSelect from '@common/components/common/tree-select'

// 导入/更新策略
const types = [
    // {
    //     label: '按照修改时间更新',
    //     value: '按照修改时间更新',
    // },
    {
        label: '覆盖',
        value: '覆盖',
    },
]

export default {
    name: 'ImportDialog',
    components: {
        TreeSelect,
    },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        treeConfig: {
            type: Object,
            default: () => {},
        },
        type: {
            type: String,
            default: '',
        },
        saveCallback: {
            type: Function,
            default: () => {},
        },
    },
    data() {
        const validatePass = (rule, value, callback) => {
            const compareField = rule.field === 'targetBusinessEnvId' ? 'importBusinessEnvId' : 'targetBusinessEnvId'
            if (value === this.form[compareField]) {
                callback(new Error())
            } else {
                callback()
            }
        }
        return {
            types,
            form: {
                importBusinessEnvId: '',
                targetBusinessEnvId: '',
                strategy: '',
            },

            rules: {
                importBusinessEnvId: [
                    { required: true, message: '导入环境不能为空' },
                    { validator: validatePass, message: '不能在同一个环境进行导入更新', trigger: 'change' },
                ],
                targetBusinessEnvId: [
                    { required: true, message: '目标环境不能为空' },
                    { validator: validatePass, message: '不能在同一个环境进行导入更新', trigger: 'change' },
                ],
                strategy: [{ required: true, message: '导入/更新策略' }],
            },
            loading: {
                save: false,
            },
        }
    },
    computed: {
        visible: {
            get() {
                return this.dialogVisible
            },
            set(val) {
                !val && this.cancelCallback()
            },
        },
    },
    watch: {
        visible: {
            immediate: true,
            handler(val) {
                if (!val) {
                    this.paramObj = {}
                }
            },
        },
    },
    methods: {
        confirmCallback() {
            this.$emit('closeDialog', '')
        },
        cancelCallback() {
            this.$emit('closeDialog', false)
        },
        validateEnvTypeField(field) {
            this.form[field] && this.$refs.form.validateField(field)
        },
        onSave() {
            this.loading.save = true
            this.$refs.form.validate(async valid =>  {
                if (valid) {
                    try {
                        let category = ''
                        this.treeConfig.evnTypeTree.forEach(item => {
                            item.children.forEach(i => {
                                if (i.value === this.form.targetBusinessEnvId) {
                                    category = i.category
                                }
                            })
                        })
                        await this.saveCallback({
                            ...this.form,
                            category,
                        })
                        this.loading.save = false
                        this.cancelCallback()
                    } catch (error) {
                        this.loading.save = false
                    }
                } else {
                    this.loading.save = false
                }
            })
        },

    },
}
</script>

<style lang="less" scoped>
@deep: ~'>>>';

@{deep} .hc-dialog .hc-select {
    width: 100% !important;
}
@{deep} .hc-input__inner {
    &::placeholder {
        font-size: 14px;
        color: rgba(62, 67, 82, 0.4);
    }
}
.import-dialog @{deep} .hc-dialog__body{
    padding: 24px 40px 22px 28px!important;
}
</style>
